import none from '../../img/kandokLogo.jpg'
export const breakfast = [
 {
  "id": 51,
  "title": "املت 1 نفره",
  "price": 70,
  "image": none
 },
 {
  "id": 52,
  "title": "املت 2 نفره",
  "price": 140,
  "image": none
 },
 {
  "id": 53,
  "title": "سوسیس تخم مرغ 1 نفره",
  "price": 90,
  "image": none
 },
 {
  "id": 54,
  "title": "سوسیس تخم مرغ 2 نفره",
  "price": 180,
  "image": none
 },
 {
  "id": 55,
  "title": "نیمرو 1 نفره",
  "price": 50,
  "image": none
 },
 {
  "id": 56,
  "title": "نیمرو 2 نفره",
  "price": 100,
  "image": none
 },
 {
  "id": 57,
  "title": "عدسی",
  "price": 60,
  "image": none
 }
]